import { PublishedProjectsState } from '@app/store/publishedProjects'

import { useAppSelector } from './useAppSelector'

export const usePublishedProjects = (): PublishedProjectsState =>
  useAppSelector((state) => state.publishedProjects)
